import React, { useEffect, useState } from 'react';
import { Dialog, DialogType, PrimaryButton, DialogFooter, DefaultButton, TextField, Icon } from '@fluentui/react';
import { dialogStyle } from '../styles/common/Dialog.style';
import { Stack, IStackProps } from '@fluentui/react/lib/Stack';
import copy from 'copy-to-clipboard';
export interface ICloseListDialogProps {
  toggle: boolean;
  initial: boolean;
  EndComment(text: string): void;
  displayTicketId: string;
}

const columnProps: Partial<IStackProps> = {
  tokens: { childrenGap: 15 },
  styles: {
    root: { width: 'auto', borderBottom: 'solid 2px #6264A7', backgroundColor: '#F3F2F1', boxSizing: 'border-box' }
  }
};

const modalProps = {
  isBlocking: false,
  className: 'OpenModifyDialog',
  styles: { main: { height: 295, padding: 10 }, overflow: 'hidden' }
};

const CloseListDialog: React.FC<ICloseListDialogProps> = ({ toggle, initial, EndComment, displayTicketId }) => {
  const [close, setclose] = useState(true);
  const [text, setText] = useState('');
  const [isBlur, setIsBlur] = useState<any>(false);
  const [isCopythis, setIsCopythis] = useState<any>(false);
  const copyContent = () => {
    //复制知识库内容
    let text = displayTicketId;
    text && copy(text);
    setIsCopythis(true);
  };

  const dialogContentProps = {
    type: DialogType.normal,
    title: (
      <div style={{ display: 'flex', flexDirection: "column", justifyContent: 'space-between', overflow: 'hidden' }}>
        您确定要关闭工单吗？{' '}
        <br></br>
        <span style={{ fontSize: '12px', marginTop: "15px" }}>
          工单编号：{displayTicketId}{' '}
          <Icon
            style={{
              marginLeft: '5px', width: '24px',
              height: '24px',
              borderRadius: ' 4px',

              textAlign: 'center',
              lineHeight: '24px',
              fontSize: '8px',
              cursor: 'pointer'
            }}
            iconName={isCopythis ? 'CheckMark' : 'Copy'}
            onClick={() => copyContent()}
          />
        </span>
      </div>
    ),
    closeButtonAriaLabel: '关闭'
  };
  useEffect(() => {
    !initial && setclose(false);
  }, [toggle]);

  return (
    <Dialog
      // 关闭工单弹窗
      className={dialogStyle}
      hidden={close}
      onDismiss={() => setclose(true)}
      dialogContentProps={dialogContentProps}
      maxWidth={800}
      minWidth={552}
      // maxHeight={351}
      modalProps={modalProps}
    >
      <Stack {...columnProps}>
        <TextField
          underlined
          placeholder="简单总结本次客服（最少10个字）"
          multiline
          styles={{ root: { borderBottom: "none" }, field: { backgroundColor: "#F3F2F1" }, wrapper: { ":after": { border: "none" } } }}
          borderless={true}
          rows={5}
          onBlur={() => {
            setIsBlur(true);
          }}
          onFocus={() => {
            setIsBlur(false);
          }}
          // autoAdjustHeight={true}
          onChange={(e: any) => {
            setText(e.target.value);
          }}
        />
      </Stack>
      <div style={{ position: 'absolute', width: '100%', marginTop: '-3px' }}>
        {(isBlur && !text && (
          <span style={{ color: '#C4314B', marginTop: '0px', borderTop: 'solid 2px #C4314B', display: 'inline-block', width: '100%' }}>
            必填
          </span>
        )) ||
          (text.length > 200 && (
            <span style={{ color: '#C4314B', marginTop: '0px', display: 'inline-block', width: '100%', borderTop: 'solid 2px #C4314B' }}>
              最多200字
            </span>
          )) ||
          (text.length < 10 && text.length !== 0 && (
            <span style={{ color: '#C4314B', display: 'inline-block', marginTop: '0px', width: '100%', borderTop: 'solid 2px #C4314B' }}>
              最少10字
            </span>
          ))}

      </div>
      <DialogFooter>
        <DefaultButton
          text="取消"
          onClick={() => {
            setclose(true);
            setIsCopythis(false);
            setIsBlur(false);
          }}
        />
        <PrimaryButton
          text="确定"
          onClick={() => {
            setclose(true);
            EndComment(text);
            setIsCopythis(false);
          }}
          disabled={text.length >= 10 ? false : true}
        />
      </DialogFooter>
    </Dialog>
  );
};
export default CloseListDialog;
